import React, { memo } from 'react';
import cx from 'classnames';
import Icon from '@components/@core/Icon';

const NavItem = ({ title, icon, href, parent, active, collapsed, onClick, dataCy }) => {
    const classname = cx('nav-item', { parent, active, collapsed });

    const spanClass = cx('dsl-b14 ',  parent ? 'text-800' : 'text-400');
    return (
        <div className={classname} onClick={() => (parent ? {} : onClick())}>
            {collapsed ? (
                <Icon size={20} name={icon} color="#c3c7cc" data-cy={dataCy} />
            ) : (
                <span className={spanClass} data-cy={dataCy}>
                    {title}
                </span>
            )}
        </div>
    );
};

export default memo(NavItem);
